export const SIZES = ["XS", "S", "M", "L", "XL", "XXL"];
